import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import type { Team } from "@/types/team";
import { Edit, UserPlus, Users } from "lucide-react";

interface TeamCardProps {
  team: Team;
  onEdit: () => void;
  onManageAgents: () => void;
}

export default function TeamCard({
  team,
  onEdit,
  onManageAgents,
}: TeamCardProps) {
  return (
    <Card key={team._id} className="min-w-[250px]">
      <div className="p-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-semibold">{team.name}</h3>
          <Badge variant="outline" className="bg-muted">
            {team.isActive ? "Ativo" : "Inativo"}
          </Badge>
          <div className="flex gap-1">
            <Button variant="ghost" size="icon" onClick={onEdit}>
              <Edit className="h-4 w-4" />
            </Button>
          </div>
        </div>

        {team.description && (
          <p className="text-sm text-muted-foreground mb-4">
            {team.description}
          </p>
        )}

        <div className="flex items-center justify-between">
         
          <div className="flex items-center gap-2">
            <div className="flex items-center gap-1">
              <Users className="h-4 w-4 text-muted-foreground" />
              <span className="text-sm">{team.memberCount || 0} membros</span>
            </div>
            <Button
              variant="outline"
              size="sm"
              className="gap-1 h-8"
              onClick={onManageAgents}
            >
              <UserPlus className="h-3 w-3" />
              Gerenciar
            </Button>
          </div>
        </div>
      </div>
    </Card>
  );
}
